import React from 'react';
import { Helmet } from 'react-helmet-async';
import Footer from "./en/Footer";
import PageHeader from "./en/PageHeader";
import CoverPage from "./en/CoverPage";
import Overview from "./en/Overview";
import Results from "./en/Results";
import ReportService from "../services/ReportService";
import MovingForward from "./en/MovingForward";
import ResultSeparated from "./en/ResultSeparated";
import { useLocation } from 'react-router-dom';
import {getQueryParams} from "../services/UtilityService";
import {ITPColorsLegend} from "./constants";
import ITPAssessmentsService from "../services/ITPAssessmentsService";

const getImplicationBlock = (dimension, score) => {
    const list = ReportService.ITPImplicationsMappings[dimension];
    if (!list) throw new Error(`Unknown dimension: ${dimension}`);
    return list.find(b => ReportService.formatITPScore(score) >= b.minScore && ReportService.formatITPScore(score) <= b.maxScore);
}
const ITPAssessmentReport = () => {
    const location = useLocation();
    const params = getQueryParams(location.search);
    const reportData = ITPAssessmentsService.getReportData(params);
    let assessment = {
        name: `JohnDummy DoeDummy`,
        firstName: 'John',
        score: {
            HUMBLE: 3.2,
            SMART: 2.2,
            HUNGRY: 1.4
        },
        sortedScore: Object.entries({
            HUMBLE: 3.2,
            SMART: 2.2,
            HUNGRY: 1.4
        }),
    };

    if(reportData){
        const results = reportData?.results?.[0]?.ASSESSMENT;
        const sortedScore = {
            [results?.rank1]:  results?.rank1Score,   // SMART: 2.2
            [results?.rank2]:  results?.rank2Score,   // HUNGRY: 3
            [results?.rank3]:  results?.rank3Score    // HUMBLE: 4.6
        }
        assessment = {
            name: `${reportData?.firstName} ${reportData?.lastName}`,
            firstName: reportData?.firstName,
            score: sortedScore,
            sortedScore: Object.entries(sortedScore),
        }
    }

    const renderResults = (assessment) => {
        const resultCharts = assessment?.sortedScore?.map(([key, score], idx) => {
            const { name, texts } = ReportService.ITPResultMapping[key];
            const { label, color } = Object.values(ITPColorsLegend).find(({min, max}) =>
                ReportService.formatITPScore(score) >= min && ReportService.formatITPScore(score) <= max);
            const description = texts[label];
            return {
                key,
                color,
                name,
                description,
                score
            }
        });
        return (
            <section role='region' className='Page'>
                <Results assessment={assessment} scoring={resultCharts} />
                <Footer page={2} />
            </section>
        )
    }
    const renderScoring = (assessment) => {
        return assessment?.sortedScore?.map(([key, value], index) => {
            const scoringValues = getImplicationBlock(key, value);
            console.log({scoringValues});
            return (
                <section key={`KeyImplicationsSection_${key}`} role='region' className='Page'>
                    <PageHeader key={`PageHeader_KeyImplications_${key}`} title={'RESULTS'} />
                    {/*<KeyImplications assessment={null} item={item} page_number={index+3} />*/}
                    <ResultSeparated title={key} assessment={assessment} item={scoringValues} page_number={index+3} />
                    <Footer key={`KeyImplications_Footer_${key}`} page={index+3} />
                </section>
            )
        })
    }
    const renderContent = () => {
        if (assessment?.sortedScore?.some(([key, score]) => score <=0 )) {
            return null;
        }

        return (
           <div id={'itp-assessment-report'} className={'itp-pdf-assessment-report'}>
               <section role='region' className='Page CoverPage'>
                   <CoverPage assessment={assessment} />
               </section>
               <section role='region' className='Page'>
                   <Overview />
                   <Footer page={1} />
               </section>
               {renderResults(assessment)}
               {renderScoring(assessment)}
               <section role='region' className='Page'>
                   <MovingForward assessment={assessment} />
                   <Footer page={6} />
               </section>
           </div>
        )
    };

    return (
        <>
            <Helmet>
                <meta charSet='UTF-8' />
                <meta name='viewport' content='width=device-width, initial-scale=1.0' />
                <meta httpEquiv='X-UA-Compatible' content='ie=edge' />
                <link rel='stylesheet' href='/report/pdf.css' />
                <title>ITP Assessment Report</title>
            </Helmet>
            {renderContent()}
        </>
    );
};

export default ITPAssessmentReport;
